import { PrintLayout, PrintWidth } from '@/@types/print';

export const PRINT_LAYOUTS: Array<{ id: PrintLayout; label: string }> = [
  { id: 'Layout1', label: 'Layout 1' },
  { id: 'Layout2', label: 'Layout 2' },
];

export const PRINT_LAYOUT_1: PrintLayout = 'Layout1';
export const PRINT_LAYOUT_2: PrintLayout = 'Layout2';

export const PRINT_WIDTHS: Array<{ id: PrintWidth; label: string }> = [
  { id: '80mm', label: '80mm' },
  { id: '58mm', label: '58mm' },
];

export const PRINT_WIDTH_80MM: PrintWidth = '80mm';
